export var MathOperator;
(function (MathOperator) {
    MathOperator["GreaterThan"] = "GREATER_THAN";
    MathOperator["LessThan"] = "LESS_THAN";
    MathOperator["LessThanOrEquals"] = "LESS_THAN_OR_EQUALS";
    MathOperator["GreaterThanOrEquals"] = "GREATER_THAN_OR_EQUALS";
    MathOperator["Equals"] = "EQUALS";
    MathOperator["NotEquals"] = "NOT_EQUALS";
})(MathOperator || (MathOperator = {}));
//# sourceMappingURL=math-operator.enum.js.map